import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';

import { Main } from './main';

export const Integrations = () => {
  return (
    <>
      <DocumentHead title='Integrations' />
      <PageTemplate modal={[]} main={<Main />} />
    </>
  );
};
